import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { getAssetUrl } from 'utils/getAssetUrl';
import makeStyles from '@mui/styles/makeStyles';
import { UserProfile } from '@trnsact/trnsact-shared-types';
import defaultAvatar from '../../assets/img/default-avatar.png';
import HelpIcon from '@mui/icons-material/Help';
import { theme } from 'theme';
import { servicedeskUrl } from 'constants/common';

interface Props {
  isDrawerOpen: boolean;
}

export const SidebarNeedHelpSection = ({ isDrawerOpen }: Props) => {
  const classes = useStyles();

  const accountRep = useSelector((state: any) => state.accountRep) as UserProfile;

  const accountRepPhoto = accountRep?.mugshot ? getAssetUrl(accountRep.mugshot) : defaultAvatar;

  return isDrawerOpen ? (
    <Box className={classes.root}>
      <img src={accountRepPhoto} className={classes.avatarImg} alt="Account rep" />

      <Typography>{accountRep?.fullName}</Typography>

      <a rel="noopener noreferrer" href={servicedeskUrl} target="_blank">
        <Button variant="contained" className={classes.helpButton}>
          Need Help?
        </Button>
      </a>
    </Box>
  ) : (
    <Box>
      <IconButton
        className={classes.closedDrawerIconButton}
        color="primary"
        size="small"
        onClick={() => window.open(servicedeskUrl, '_blank', 'noopener,noreferrer')}
      >
        <HelpIcon sx={{ color: 'white' }} />
      </IconButton>
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  avatarImg: {
    width: 80,
    height: 80,
    overflow: 'hidden',
    borderRadius: '50%',
  },
  helpButton: {
    textTransform: 'none',
  },
  closedDrawerIconButton: {
    borderRadius: '4px',
    background: theme.palette.primary.main,
    margin: '12px',
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
});
